import api from './api';

export const aplicativoService = {
  getAll,
  getById,
  create,
  update,
  destroy
};

function getAll(page = 1, limit = 25, status = '', query = '') {
  let queryStr = `?page=${page}&limit=${limit}${status && `&status=${status}`}${query && `&query=${query}`}`;
  return api.get(`${process.env.VUE_APP_ROOT_API}/aplicativos${queryStr}`);
}

function getById(id) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/aplicativos/${id}`);
}

function create(aplicativo) {
  return api.post(`${process.env.VUE_APP_ROOT_API}/aplicativos`, aplicativo);
}

function update(aplicativo) {
  return api.put(`${process.env.VUE_APP_ROOT_API}/aplicativos/${aplicativo._id}`, aplicativo);
}

function destroy(id) {
  return api.delete(`${process.env.VUE_APP_ROOT_API}/aplicativos/${id}`);
}